var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTariffIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 25.5455C26.6982 26.8676 25.3514 27.9374 23.8125 28.6732C22.2736 29.4091 20.5831 29.7915 18.87 29.7915H4.6875C3.94158 29.7915 3.22621 29.5018 2.69876 28.986C2.17132 28.4703 1.875 27.7708 1.875 27.0415V17.4165C1.875 16.6872 2.17132 15.9877 2.69876 15.472C3.22621 14.9562 3.94158 14.6665 4.6875 14.6665H16.3575C16.9962 14.6667 17.6158 14.8794 18.1144 15.2697L23.25 19.2792C23.6005 19.5533 24.013 19.7415 24.453 19.8279C24.893 19.9143 25.3478 19.8965 25.7794 19.776L34.2188 17.4165L27.75 25.5455Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9.1665V14.6665",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.1665H18.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2188 17.4165L38.4375 18.7915",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6562 34.089C42.6562 35.1373 42.2303 36.1427 41.4722 36.884C40.7141 37.6252 39.6859 38.0417 38.6137 38.0417C37.5416 38.0417 36.5134 37.6252 35.7552 36.884C34.9971 36.1427 34.5712 35.1373 34.5712 34.089C34.5712 31.9 37.2656 27.5 38.6137 27.5C39.9619 27.5 42.6562 31.9 42.6562 34.089Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariffIcon2);
export default __webpack_public_path__ + "static/media/tariffIcon2.aa6435a7fa8865986ee4c76ee86a0d20.svg";
export { ForwardRef as ReactComponent };